module.exports = __webpack_public_path__ + "img/mind_skeleton_26.f9dca3bd.png";